'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-08
 */

import {Person} from 'janux-people'
import {Role} from 'janux-authorize'
import _ from 'lodash'
import jwtHelper from './jwt-helper'
import store from 'CommonApp/store'
import Cookies from 'js.cookie'

//
// When a user is returned from the back-end, hydrate each
// role json structure into a full janux Role instance
//
function hydrateRoles (user) {
	if (user && user.roles) {
		user.roles = _.map(user.roles, (role) => {
			return Role.fromJSON(role)
		})
	}
	return user
}

export function security (http) {
	const service = {

		//
		// Check if user is currently authenticated
		//
		isAuthenticated: function () {
			// Validate if there is a token
			const token = localStorage.getItem('token')
			if (_.isNil(service.currentUser) && !_.isNil(token)) {
				if (jwtHelper.isTokenExpired(token) === false) {
					var tokenPayload = jwtHelper.decodeToken(token)
					service.currentUser = hydrateRoles(tokenPayload)
					service.currentUser.contact = Person.fromJSON(service.currentUser.contact)
				}
			}
			const out = !_.isNil(service.currentUser)
			let role = null
			if (out) {
				role = service.currentUser.roles[0].toJSON()
				// console.debug('user role is  ', role)
			}
			service.setSharedLoginStatus(out, role, token)
			return out
		},

		//
		// Authenticate the user with username and password
		//
		login: function (username, password) {
			return http.post('/login', {username: username, password: password}).then((response) => {
				let user = response.data.user
				console.log('login user:', user)
				if (user) {
					console.log('login response:', response.data.user.roles[0].isAlmighty)
					service.currentUser = hydrateRoles(response.data.user)
					service.currentUser.contact = Person.fromJSON(service.currentUser.contact)
					service.token = response.data.token
					// Save the token in local storage.
					localStorage.setItem('token', service.token)
					return service.isAuthenticated()
				}
				return null
			})
		},

		//
		// Clear token in case user request logout
		// or token gets expired during a request
		//
		clearLoginData: function () {
			service.currentUser = null
			localStorage.removeItem('token')
		},

		//
		// Request user logout
		//
		logout: function () {
			return http.post('/logout').then((resp) => {
				// console.debug("logout resp:", JSON.stringify(resp));
				service.clearLoginData()
				return resp
			})
		},

		//
		// Check if user is authenticated and return its data
		//
		requestCurrentUser: function () {
			if (service.isAuthenticated()) {
				console.log('currentUser-cached:', service.currentUser)
				// Get current User
				return new Promise((resolve, reject) => {
					resolve(service.currentUser)
				})
			} else {
				return http.get('/current-user').then((response) => {
					// Set current User
					service.currentUser = hydrateRoles(response.data.user)
					if (typeof response.data.user !== 'undefined') {
						service.currentUser.contact = Person.fromJSON(response.data.user.contact)
					}
					console.log('currentUser-served:', service.currentUser)
					return service.currentUser
				})
			}
		},

		set currentUser (currentUser) {
			store.dispatch({
				type: 'updateCurrentUser',
				value: currentUser
			})
		},

		get currentUser () {
			return store.state.currentUser
		},

		setSharedLoginStatus: function (status, role, token) {
			// console.log('setting login status', status)
			// Get domain
			const hostname = window.location.hostname
			const domain = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1)
			// Set domain shared status cookie
			const statusObj = { status, role, token }
			// console.log('token ', token)
			Cookies.set('e24AppLoginStatus', statusObj, { domain: domain, expires: 1 })
		}
	}

	return service
}



// WEBPACK FOOTER //
// ./src/common/security/security-service.js